import { Skeleton, Stack } from '@mantine/core'

export const PostSkeleton = () => {
	return (
		<Stack gap={'md'}>
			<Skeleton height={32} />
			<Skeleton height={32} width={'80%'} />
			<Skeleton my={'xl'} height={500} radius={'lg'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'95%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'90%'} />
			<Skeleton height={12} width={'70%'} />
			<Skeleton height={12} width={'95%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'90%'} />
			<Skeleton height={12} width={'70%'} />
			<Skeleton mt={'xl'} height={24} width={'60%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'95%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'90%'} />
			<Skeleton height={12} width={'70%'} />
			<Skeleton height={12} width={'95%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'90%'} />
			<Skeleton height={12} width={'70%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'90%'} />
			<Skeleton height={12} width={'70%'} />
			<Skeleton height={12} width={'95%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'90%'} />
			<Skeleton height={12} width={'70%'} />

			<Skeleton mt={'xl'} height={24} width={'50%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'95%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'90%'} />
			<Skeleton height={12} width={'70%'} />
			<Skeleton height={12} width={'95%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'90%'} />
			<Skeleton height={12} width={'70%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'90%'} />

			<Skeleton mt={'xl'} height={24} width={'60%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'95%'} />
			<Skeleton height={12} />
			<Skeleton height={12} width={'90%'} />
			<Skeleton height={12} width={'70%'} />
		</Stack>
	)
}
